import { SvelteSet } from 'svelte/reactivity';
import type { Coord, Tile } from '~/types';

export class Dragging<T extends {}> {
  timestamp = $state(0);
  id = $state<string>();
  origin = $state<Coord>();
  coords = $state<{ x: number; y: number }>();
  hovered = $state<T>();
  returning = $state(new SvelteSet<string | number>());

  reset() {
    this.timestamp = 0;
    this.returning = new SvelteSet();
  }
  clear() {
    this.id = undefined;
    this.origin = [-1, -1];
    this.hovered = undefined;
  }
}
